/**
 * Oleum Vitae — analytics GA4 / dataLayer
 */
(function (global) {
  'use strict';

  function ensureDataLayer() {
    global.dataLayer = global.dataLayer || [];
    return global.dataLayer;
  }

  function clip(val, max) {
    if (val == null) return '';
    var s = String(val);
    return s.length <= (max || 100) ? s : s.substring(0, max || 100);
  }

  function contextPayload(ctx, extra) {
    ctx = ctx || {};
    extra = extra || {};
    return {
      role: ctx.role || '',
      profile: ctx.profile || '',
      intent: ctx.intent || '',
      benefit: ctx.benefit || '',
      aroma: ctx.aroma || '',
      use_method: ctx.use_method || '',
      experience_level: ctx.experience_level || '',
      route: ctx.route || '',
      recommended_product_ids: extra.recommended_product_ids || [],
      clicked_product_id: extra.clicked_product_id || '',
      step: extra.step || '',
      step_name: extra.step_name || ''
    };
  }

  function trackOleumEvent(eventName, payload) {
    payload = payload || {};
    var dl = ensureDataLayer();
    var base = {
      event: eventName,
      oleum_event: eventName,
      oleum_timestamp: new Date().toISOString()
    };
    Object.keys(payload).forEach(function (k) {
      base[k] = payload[k];
    });
    dl.push(base);

    if (typeof global.gtag === 'function') {
      global.gtag('event', eventName, {
        event_category: 'oleum_segmentador',
        event_label: clip(payload.step_name || payload.profile || eventName),
        role: clip(payload.role),
        profile: clip(payload.profile),
        intent: clip(payload.intent)
      });
    }
  }

  function trackSegmentStart(ctx) {
    trackOleumEvent('ov_segment_start', contextPayload(ctx));
  }

  function trackSegmentStep(ctx, step, stepName) {
    trackOleumEvent('ov_segment_step', contextPayload(ctx, { step: step, step_name: stepName }));
  }

  function trackSegmentComplete(ctx, result) {
    var ids = (result && result.recommended_product_ids) || [];
    trackOleumEvent('ov_segment_complete', contextPayload(ctx, { recommended_product_ids: ids }));
  }

  function trackRecommendationsView(ctx, result) {
    trackOleumEvent('ov_recommendations_view', contextPayload(ctx, {
      recommended_product_ids: (result && result.recommended_product_ids) || []
    }));
  }

  function trackProductClick(ctx, productId) {
    trackOleumEvent('ov_product_click', contextPayload(ctx, { clicked_product_id: productId }));
  }

  function trackAddToCart(ctx, productId) {
    trackOleumEvent('ov_add_to_cart', contextPayload(ctx, { clicked_product_id: productId }));
  }

  global.OleumAnalytics = {
    trackOleumEvent: trackOleumEvent,
    trackSegmentStart: trackSegmentStart,
    trackSegmentStep: trackSegmentStep,
    trackSegmentComplete: trackSegmentComplete,
    trackRecommendationsView: trackRecommendationsView,
    trackProductClick: trackProductClick,
    trackAddToCart: trackAddToCart
  };
})(typeof window !== 'undefined' ? window : globalThis);
